var map = {
	"./Abarrotes.png": 3505,
	"./Carniceria.png": 6283,
	"./Empresa.png": 7447,
	"./Fabrica.png": 4698,
	"./Feria.png": 7087,
	"./Kiosco.png": 8888,
	"./Mayorista.png": 8207,
	"./Puesto movil.png": 4231,
	"./Restaurante.png": 7556,
	"./Tienda.png": 8581,
	"./avatar.png": 4211,
	"./location_back.png": 6595,
	"./location_danger.png": 6631,
	"./location_info.png": 8434,
	"./location_success.png": 5373,
	"./location_warning.png": 6488,
	"./profile.png": 7653,
	"./sarisoya-logo.png": 3135,
	"./sarisoya-logo1.png": 678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;